<ul>
  <li>【開催日】8月25日（日）</li>
  <li>【開催時間】10:00～18:00</li>
  <li>【開催場所】東京都新宿区新宿6-27-30 <a href="https://maps.app.goo.gl/VzdoicH9gptwUrHT6" target="_blank">地図</a><br>新宿イーストサイドスクエア Eastオフィス11F</li>
</ul>
<form [formGroup]="form">
  <div>
    <p><span class="label">お名前</span></p>
    <input type="text" formControlName="name" required [class.error]="form.controls.name.touched && form.controls.name.invalid">
    @if (form.controls.name.touched && form.controls.name.invalid) {
    <mat-error>お名前を入力してください</mat-error>
    }
  </div>
  <div>
    <p><span class="label">携帯電話</span></p>
    <input type="tel" formControlName="phone" required [class.error]="form.controls.phone.touched && form.controls.phone.invalid" pattern="\d{11}">
    @if (form.controls.phone.touched && form.controls.phone.hasError('required')) {
    <mat-error>携帯電話を入力してください</mat-error>
    } @else if (form.controls.phone.touched && form.controls.phone.hasError('pattern')) {
    <mat-error>携帯電話の形式が不正です</mat-error>
    }
  </div>
  <div>
    <p><span class="label">フェア参加の希望時間</span></p>
    <div class="co-form__selectWrapper">
      <select class="co-form__select" formControlName="hopeTime">
        <option value="第1回 10:00 受付 9:30～">第1回 10:00 受付 9:30～</option>
        <option value="第2回 13:00 受付 12:30～">第2回 13:00 受付 12:30～</option>
        <option value="第3回 16:00 受付 15:30～">第3回 16:00 受付 15:30～</option>
      </select>
    </div>
    @if (form.controls.hopeTime.touched && form.controls.hopeTime.invalid) {
      <mat-error>希望時間を選択してください</mat-error>
    }
  </div>

  <div>
    <p><span class="label">参加形式</span></p>
    <div class="co-form__selectWrapper">
      <select class="co-form__select" formControlName="attendType">
        <option value="現地参加を希望する">現地参加を希望する</option>
        <option value="オンライン参加を希望する">オンライン参加を希望する</option>
      </select>
    </div>
    @if (form.controls.attendType.touched && form.controls.attendType.invalid) {
      <mat-error>参加形式を選択してください</mat-error>
    }
  </div>
  <div class="cv-button" (click)="submit()"><img decording="async" src="https://ryugaku.yume-kana.com/wp-content/themes/yumekana-renewal/assets/image/lp/20240731_fair_06.jpg" alt="留学・ワーホリフェアに参加して特典をゲットする"></div>
</form>
